import { ReactNode } from 'react';
import type { DynamicFormApi } from '../hooks/use-app-form';
import { useConditionalFieldHidden } from '../hooks/use-conditional-field-hidden';
import type { DynamicFormField } from '../types';

interface ConditionalFieldProps {
  form: DynamicFormApi;
  fieldInfo: DynamicFormField;
  children: ReactNode;
}

/** Applies show/hide conditions to any dynamic-form field; hidden fields are unmounted and skip validation. */
export const ConditionalField = ({ form, fieldInfo, children }: ConditionalFieldProps) => {
  const isHidden = useConditionalFieldHidden(form, fieldInfo);
  return isHidden ? null : <>{children}</>;
};
